// Each fragment flips from the animation colour to the element's own colour in turn; the stagger
// is the whole animation.
export function getTextColorSwitchAnimation (element, settings) {
    return {
        instant: true,
        from: { color: settings.color ?? 'transparent' },
    }
}
